module.exports = __webpack_public_path__ + "img/rope_1ThimbleLock_1eye_2.3c1f12c4.png";